export const personal = {
  name: "Yuvan R",
  role: "Full-Stack Developer",
  tagline: "Building scalable web platforms, intelligent AI tools, and real-time systems.",
  bio1:
    "I'm a Computer Science student at BMS Institute of Technology with a 9.65 CGPA. I sit at the intersection of clean architecture, AI, and real-world impact.",
  bio2:
    "I build full-stack applications using the MERN stack, explore Generative AI integrations with Gemini AI, and enjoy solving algorithmic problems to sharpen my systems thinking.",
  github: "https://github.com/YUVAN-cse",
  linkedin: "https://linkedin.com/in/yuvan-r-92356732a",
  email: "yuvan@example.com",
};

export const stats = [
  { num: "19", label: "Repositories" },
  { num: "9.65", label: "CGPA / 10" },
  { num: "Top 50", label: "CodeRed24 Hackathon" },
];

export const skills = [
  "JavaScript", "TypeScript", "React", "Node.js",
  "Next.js", "MongoDB", "Gemini AI", "Socket.io",
  "Docker", "Firebase", "Java", "Python", "Express.js", "MySQL",
];

export const techStack = [
  "React", "Node.js", "MongoDB", "Gemini AI", "Socket.io",
  "TypeScript", "Next.js", "Docker", "Firebase", "Express.js",
  "Tailwind CSS", "JWT", "REST APIs", "Cloudinary",
];

export const achievements = [
  {
    icon: "🏆",
    title: "CodeRed24 Hackathon Finalist",
    sub: "Top 50 nationally",
  },
  {
    icon: "🎓",
    title: "Academic Excellence",
    sub: "CGPA 9.65 / 10 — BMS Institute of Technology",
  },
];

export const projects = [
  {
    id: "01",
    featured: true,
    title: "AI Resume Analyzer",
    desc: "An AI-powered career assistant that analyzes resumes against job descriptions, detects skill gaps, generates tailored interview questions, and produces ATS-friendly resumes with downloadable PDF reports.",
    stack: ["React", "Node.js", "MongoDB", "Gemini AI", "PDF Reports"],
    github: "https://github.com/YUVAN-cse/AI-Resume-Analyzer",
    live: null,
  },
  {
    id: "02",
    featured: false,
    title: "StreamVault",
    desc: "Full-stack YouTube clone with video upload, playback, likes, comments, subscriptions, playlists, and Cloudinary integration.",
    stack: ["React", "Node.js", "MongoDB", "Cloudinary", "Tailwind CSS", "JWT"],
    github: "https://github.com/YUVAN-cse/StreamVault",
    live: null,
  },
  {
    id: "03",
    featured: false,
    title: "NobleNest",
    desc: "Airbnb-style full-stack rental platform. Users discover, list, and manage property listings with secure authentication.",
    stack: ["Node.js", "Express", "MongoDB", "EJS"],
    github: "https://github.com/YUVAN-cse/Noblenest",
    live: "https://noblenest-6qwf.onrender.com",
  },
  {
    id: "04",
    featured: false,
    title: "Winter AI ChatApp",
    desc: "Full-stack AI chat app with threaded conversations, JWT auth with refresh tokens, and a dark space-themed UI powered by Gemini 2.0.",
    stack: ["React", "Node.js", "MongoDB", "Gemini 2.0", "JWT"],
    github: "https://github.com/YUVAN-cse/Winter-AI-ChatApp",
    live: null,
  },
  {
    id: "05",
    featured: false,
    title: "Real-Time Chat",
    desc: "Real-time messaging platform supporting live chat, chat rooms, and user presence indicators via WebSockets.",
    stack: ["React", "Socket.io", "Node.js", "MongoDB"],
    github: "https://github.com/YUVAN-cse/Real-Time-Chat-Application",
    live: null,
  },
  {
    id: "06",
    featured: false,
    title: "DataLens",
    desc: "Production-ready full-stack app that transforms any CSV file into a rich, interactive analytics dashboard.",
    stack: ["TypeScript", "React", "Express", "D3.js"],
    github: "https://github.com/YUVAN-cse/DataLens",
    live: null,
  },
];
